import React from "react";
import { connect } from "react-redux";

import SelectEmpresas from "./selectEmpresas";
import SelectSucursales from "./selectSucursales";

import { resetStateSolicitudes } from "../../SucursalVirtual/Empresa/GestionUsuarios/AprobarSolicitudes/actions";
import { setTypeRelationFilter } from "../../SucursalVirtual/Empresa/GestionUsuarios/Notificaciones/actions";
import { doFindCompanies, setCompanyId, setSucursalId } from "../../Global/actions";
import { getListadoPlanesMovilidad, getEstadisticasPlanMovilidad, limpiarPlanMovilidad, getListadoContenidosCompleto, getAccidentesList } from "../Planes/actions";
import { dataLayerTag } from "../Planes/functions";

class Sucursal extends React.Component {
  constructor(props) {
    super(props);

    if (!props.listaEmpresas && props.userData && props.userData.RUT) props.dispatch(doFindCompanies(props.userData.RUT));

    this.node = React.createRef();

    this.state = {
      selectCompanyOpen: false,
      selectSucursalOpen: false,
    };
  }

  handleSucursalSelect = (open) => {
    if (this.state.selectSucursalOpen && open) {
      open = false;
    }
    this.setState({ selectSucursalOpen: open });
  }

  handleCompanySelect = (open) => {
    let isOpen = open;
    if (this.state.selectCompanyOpen && open) {
      isOpen = false;
    }
    this.setState({ selectCompanyOpen: isOpen });
  }
  getCompany = (e, value) => {
    const { dispatch } = this.props;
    const { RutEmpresa, Nombre} = value;
    dispatch(resetStateSolicitudes());
    dispatch(setTypeRelationFilter("INT"));
    dispatch(setCompanyId(RutEmpresa, Nombre, this.handleSucursalSelect));
  }

  getSucursal = (e, value) => {
    const { dispatch, usuarioRUT } = this.props;
    const { idSucursal, Direccion } = value;
    dispatch(getListadoContenidosCompleto());
    dispatch(setSucursalId(idSucursal, Direccion));
    dispatch(limpiarPlanMovilidad());
    dataLayerTag({
      'event': 'sucursal_seleccionada',
      'rut': usuarioRUT,
      'sucursal': (Direccion && Direccion !== "" ? Direccion: 'undefined'),
      'bp_sucursal': (idSucursal && idSucursal !== "" ? idSucursal : 'undefined'),
      });
  }

  componentDidUpdate(prevProps){
    const { dispatch, sucursalId, usuarioRUT, companyId } = this.props;
    if (prevProps.sucursalId !== sucursalId){
      dispatch(getListadoPlanesMovilidad(companyId, sucursalId, usuarioRUT));
      dispatch(getEstadisticasPlanMovilidad(companyId, sucursalId, ""));
      dispatch(getAccidentesList(companyId, sucursalId));
    }
  }


  render() {
    const {
      companyId,
    } = this.props;
    const { 
      externalCompanyId
    } = this.state;
    return (
      <React.Fragment>
        <SelectEmpresas
          show
          dataSource={this.props.listaEmpresas}
          value={companyId}
          handleChange={this.getCompany}
          open={this.state.selectCompanyOpen}
          handleOpenClose={this.handleCompanySelect}
        />
        <SelectSucursales
          show
          dataSource={[
            { Direccion: "Todas las sucursales", idSucursal: "" },
            ...this.props.companySucursales,
          ]}
          value={this.props.sucursalId}
          handleChange={this.getSucursal}
          open={this.state.selectSucursalOpen}
          handleOpenClose={this.handleSucursalSelect}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  currentPath: state.router.location.pathname,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  sucursalName: state.global.sucursalName,
  usuarioRUT: state.global.userData.RUT,
  listaEmpresas: state.global.listaEmpresas,
  companySucursales: state.global.companySucursales,
  preventNavigation: state.global.preventNavigation,
  userAccessList: state.global.userAccessList,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Sucursal);
